package org.example.project.screens_sys

internal fun formatWebsiteDuration(value: String): String {
    val clock = Regex("""^(\d+):([0-5]\d):([0-5]\d)$""").matchEntire(value.trim())
    if (clock != null) {
        return "${clock.groupValues[1].padStart(2, '0')}:${clock.groupValues[2]}:${clock.groupValues[3]}"
    }

    val oldFormat = Regex("""^(?:(\d+)\s*Min\.\s*)?(\d+)\s*Sek\.$""").matchEntire(value.trim())
    val minutes = oldFormat?.groupValues?.get(1)?.toLongOrNull() ?: 0L
    val seconds = oldFormat?.groupValues?.get(2)?.toLongOrNull() ?: 0L
    val totalSeconds = minutes * 60 + seconds
    val hours = totalSeconds / 3600
    val remainingMinutes = totalSeconds % 3600 / 60
    val remainingSeconds = totalSeconds % 60
    return "${hours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}"
}
